import { apiClient } from "@/lib/api-client"
import { HttpStatusCodes } from "@/lib/http-status-codes"

export type Sage300EmployeeImportStatus =
  | "Pending"
  | "InProgress"
  | "Completed"
  | "Failed"

export interface StartEmployeeImportResponse {
  success: boolean
  message: string
  runId?: string
}

export interface EmployeeImportStatusResponse {
  runId: string
  status: Sage300EmployeeImportStatus
  total: number
  updated: number
  skipped: number
  isTerminal: boolean
  isSuccess: boolean
  lastErrorPayload: string | null
  createdAt: string
  updatedAt: string
}

export async function startEmployeeImport(
  organizationId: string,
): Promise<StartEmployeeImportResponse> {
  const response = await apiClient.post<StartEmployeeImportResponse>(
    `/organizations/${organizationId}/sage300/employees/import`,
  )
  return response.data
}

export async function getEmployeeImportStatus(
  organizationId: string,
  runId: string,
): Promise<EmployeeImportStatusResponse | null> {
  try {
    const response = await apiClient.get<EmployeeImportStatusResponse>(
      `/organizations/${organizationId}/sage300/employees/import/${runId}`,
    )
    return response.data
  } catch (err: unknown) {
    const status =
      typeof err === "object" && err !== null
        ? ((err as { response?: { status?: number } }).response?.status ?? 0)
        : 0
    if (status === HttpStatusCodes.NOT_FOUND) return null
    throw err
  }
}

export async function getLatestEmployeeImportStatus(
  organizationId: string,
): Promise<EmployeeImportStatusResponse | null> {
  try {
    const response = await apiClient.get<EmployeeImportStatusResponse>(
      `/organizations/${organizationId}/sage300/employees/import/latest`,
    )
    return response.data
  } catch (err: unknown) {
    const status =
      typeof err === "object" && err !== null
        ? ((err as { response?: { status?: number } }).response?.status ?? 0)
        : 0
    if (status === HttpStatusCodes.NOT_FOUND) return null
    throw err
  }
}

export const sage300EmployeeImportService = {
  startEmployeeImport,
  getEmployeeImportStatus,
  getLatestEmployeeImportStatus,
}
